import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import Moment from 'react-moment';
import SvgIcon from 'react-icons-kit';
import {plus} from 'react-icons-kit/icomoon/plus';
import swal from 'sweetalert';

var Config = require('../../../config');

class ModalReject extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.rejectDonation = this.rejectDonation.bind(this);
		
		this.state = {
            show: false,
            donation_id:"",
            reject_reason:"",
            reasons:[]
		};
	}

	componentDidMount() {
        this.props.onRef(this);
        
        
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false});
	}

	handleShow(donation_id) {
        fetch(Config.default.apiGateway.URL+'lookups/order_by?type=direct_reject_reason&option=name',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(error) {
                swal('¡Error', error, 'error');
              });
	        }
	    })
		.then((response) => {
			if(response !== "" && response !== null){
				this.setState({
                    reasons: response,
                    show: true,
                    donation_id: donation_id
				});
			}
		});
		
    }
    
    handleChange(e){
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    rejectDonation(){
        if(this.state.reject_reason !== ""){
            var obj = {
                donation_id: this.state.donation_id,
                reject_reason: this.state.reject_reason
            }

            fetch(Config.default.apiGateway.URL+'donations/reject_donation',{
                method:'POST',
                body:JSON.stringify(obj),
                headers: new Headers({
                    'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                    'Accept'        : 'application/json',
                    'Content-Type'  : 'application/json'
                })
            }).then(res => {
                if(res.ok){
                    return res.json();
                }else{
                    res.text().then(msg => 
                        swal('Error', msg, 'error')    
                    );
                }
            }).then(response => {
                if(response !== undefined){
                    window.location.reload();
                }
            })
        }else{
            swal('Error', 'Debe seleccionar un motivo', 'error');
        }
    }

	render(){
		const { t } = this.props;
		return(
			<Modal bsSize="sm" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Rechazar Donación</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12" style={{paddingBottom:"10px"}}>
                            <div className="col-xs-12">
                                <span className="span-min">Motivo</span>
                                <select className="form-control input-sm" name="reject_reason" id="reject_reason"
                                    value={this.state.reject_reason} onChange={(e)=>this.handleChange(e)}>
                                    <option value="">Seleccione...</option>
                                    {this.state.reasons.map((r, i)=>
                                        <option key={i} value={r.name}>{r.name}</option>
                                    )}
                                </select>
                            </div>
                        </div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
                    <FlatButton primary={true} label={t('content.generics.buttons.save')} onClick={this.rejectDonation}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')} onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalReject);